import SectionHeading from "@/pages/home/components/SectionHeading";

const channels = [
  {
    icon: "ri-mail-send-line",
    label: "投稿线索",
    value: "tip@juguangtai.example.com",
    desc: "适合补充文字材料、批量截图打包与较长的说明。",
    href: "mailto:tip@juguangtai.example.com",
  },
  {
    icon: "ri-scales-3-line",
    label: "反证与更正",
    value: "appeal@juguangtai.example.com",
    desc: "当事人对已发布内容有异议，可提交反证申请更正或撤下。",
    href: "mailto:appeal@juguangtai.example.com",
  },
  {
    icon: "ri-team-line",
    label: "品牌与媒体合作",
    value: "press@juguangtai.example.com",
    desc: "内容转载、联合核验与媒体采访，请注明来意与联系方式。",
    href: "mailto:press@juguangtai.example.com",
  },
];

export default function Contact() {
  return (
    <section id="contact" className="w-full bg-background-100 py-14 md:py-24">
      <div className="w-full px-4 md:px-10">
        <SectionHeading
          align="center"
          eyebrow="联系我们"
          title="有材料、有疑问、有异议，都可以找我们"
          desc="聚光台是线上运作的核验平台，没有实体接待点。所有沟通都通过邮箱进行，我们会在三个工作日内回复。"
        />

        <div className="mt-10 md:mt-14 grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {channels.map((item, index) => (
            <a
              key={item.label}
              href={item.href}
              className="reveal bg-background-50 border border-background-200 rounded-lg p-5 md:p-7 flex flex-col gap-3 hover:border-primary-300 transition-colors cursor-pointer"
              style={{ animationDelay: `${index * 0.07}s` }}
            >
              <span className="w-11 h-11 rounded-md bg-primary-100 text-primary-600 flex items-center justify-center">
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950">{item.label}</h3>
              <strong className="text-sm text-primary-700 break-all">{item.value}</strong>
              <p className="text-sm leading-relaxed text-foreground-600 flex-1">{item.desc}</p>
              <span className="text-sm font-medium text-foreground-700 flex items-center gap-1 whitespace-nowrap">
                发送邮件
                <i className="ri-arrow-right-up-line"></i>
              </span>
            </a>
          ))}
        </div>

        <div className="reveal mt-8 md:mt-10 bg-accent-50 border border-accent-200 rounded-lg px-5 md:px-7 py-5 md:py-6 flex flex-col md:flex-row md:items-center gap-4 justify-between">
          <div>
            <h3 className="font-heading text-base md:text-lg font-bold text-accent-900">
              材料还没整理好？其实顺序可以反过来
            </h3>
            <p className="mt-1.5 text-sm text-foreground-600">
              先把手上有的截图发过来，编辑组会告诉你还缺哪些环节，再一起补全。
            </p>
          </div>
          <a
            href="#submit"
            className="shrink-0 inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
          >
            <i className="ri-send-plane-fill"></i>
            去匿名投稿
          </a>
        </div>
      </div>
    </section>
  );
}